import { normalize, schema } from 'normalizr';
import { atom, atomFamily } from 'recoil';
import {
  fightingRankStorage,
  imagesV3Data,
  imagesV3Shop,
  numberRankStorage
} from '../services';
import EcoinImage from '../images/gold@3x.png';
import { isNil, mergeDeepLeft } from 'ramda';

export const mainTabState = atom({
  key: 'MaibTab',
  default: 1
});

export const subTabState = atomFamily({
  key: 'SubTab',
  default: (_index: number) => 1
});

export const imagePopupState = atomFamily({
  key: 'ImagePopup',
  default: (_type: ImageV3State.PopupType) => ({
    visible: false,
    target: 0,
    type: 0
  })
});

export const evolutionProbState = atom({
  key: 'EvolutionProb',
  default: {
    base: 0,
    extra: 0
  }
});

export const evolutionAdditionsState = atom({
  key: 'EvolutionAdditions',
  default: [] as number[]
});

export const resultState = atom<
  ImageV3API.EvolutionResult | ImageV3API.PolishResult | null
>({
  key: 'ResultState',
  default: null
});

const ability = new schema.Entity('abilities', {}, { idAttribute: 'talentId' });
const image = new schema.Entity('images', {
  highTalent: ability,
  talent: ability
});
const material = new schema.Entity(
  'materials',
  {},
  {
    idAttribute: (v: ImageV3API.Material) => {
      if (v.toolId > 0) return v.toolId;
      if (v.specialExtend && !isNil(v.specialExtend.piecesType))
        return (987654320 + v.specialExtend.piecesType) as any;
      return v.toolId;
    }
  }
);
const numberRankItem = new schema.Entity(
  'numberRanks',
  {},
  { idAttribute: 'name' }
);
const fightingRankItem = new schema.Entity('fightingRanks');

const data = new schema.Object({
  userImageList: [image],
  shopImageList: [image],
  materialList: [material],
  highToolsList: [material],
  numberRank: {
    list: [numberRankItem]
  },
  fightingRank: {
    list: [fightingRankItem]
  }
});

export const imagesDataState = atom<ImageV3State.Data>({
  key: 'ImagesData',
  effects: [
    ({ trigger, setSelf }) => {
      const signEcoin = (res: ImageV3API.Data) => {
        res.materialList.push({
          toolId: 0,
          number: res.goldCoinBalance,
          title: '金币',
          logo: EcoinImage,
          type: 0,
          specialExtend: {
            piecesType: 100
          },
          composeList: [],
          canSend: false,
          desc: ''
        });
        return res;
      };
      if (trigger === 'get') {
        const init = async () => {
          const [res1, res2, res3, res4] = await Promise.all([
            imagesV3Data.get({}),
            imagesV3Shop.get({}),
            numberRankStorage.get({}),
            fightingRankStorage.get({})
          ]);
          const res = normalize(
            {
              ...signEcoin(res1),
              shopImageList: res2,
              numberRank: res3,
              fightingRank: res4
            },
            data
          ) as any;
          return res;
        };
        setSelf(init());
      }
      const handler1 = (v: ImageV3API.Data) => {
        const res = normalize(signEcoin(v), data) as any;
        setSelf(mergeDeepLeft(res));
      };
      const handler2 = (v: ImageV3API.Image[]) => {
        const res = normalize({ shopImageList: v }, data) as any;
        setSelf(mergeDeepLeft(res));
      };

      imagesV3Data.subscribe(handler1);
      imagesV3Shop.subscribe(handler2);
      return () => {
        imagesV3Data.unsubscribe(handler1);
        imagesV3Shop.unsubscribe(handler2);
      };
    },
    ({ onSet }) => {
      onSet(console.log);
    }
  ]
});
